<template>
	<div class="bg-brand-taupe-500">
	    <PageHeader :headingContent="headingContent" />
		<div class="px-4 pb-20">
			<div class="container mx-auto md:flex">
				<div class=" md:w-2/3">
					<p><strong class="mr-1">Important:</strong>You can only view the review; you cannot alter it.</p>
				</div>
				<div class="flex md:w-1/3 md:justify-end justify-center mt-4">
					<Link href="/admin/reviews" class="">
						<button class="bg-brand-blue-400 hover:bg-brand-blue-200 text-white font-bold py-2 px-4 rounded justify-right uppercase">
							Back to list of reviews
						</button>
					</Link>
				</div>
			</div>
			<ReviewForm :reviewTemplate="reviewTemplate" :review="review" :form="form" :admin-view="true" />
			<div class="container mx-auto md:flex">
				<div class="flex w-full justify-end">
					<Link href="/admin/reviews" class="">
						<button class="bg-brand-blue-400 hover:bg-brand-blue-200 text-white font-bold py-2 px-4 rounded justify-right uppercase">
							Back to list of reviews
						</button>
					</Link>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import PageHeader from "@/Shared/PageHeader";
import Layout from "@/Shared/Layouts/Admin/Layout";
import ReviewForm from "@/Pages/Reviews/Components/ReviewForm.vue";

export default {
	components: {
		PageHeader,
		ReviewForm,
	},
	data() {
		return {
			form: this.$inertia.form({
				company: this.review.company,
				phone_number: this.review.phone_number,
				id: this.review.id,
				user_id: this.review.user_id,
				title: this.review.title,
				body: this.review.body,
				responses: this.review.responses,
				newResponses: [],
				userAction: null,
				pdf: "",
			}),
			headingContent: {
				hero: {
					image: "/images/263918963_cars_hero.jpg",
					title: "Fleet Risk Review",
					subtitle: "In association with AXA Insurance",
				},
				page: {
					title: "Reviews",
					subtitle: "",
				},
			},
		};
	},
	layout: Layout,
	props: ["review", "reviewTemplate"],
}
</script>